export * from './legalEntitiesReport.component';
export * from './legalEntitiesReport.service';
export * from './legalEntitiesWorkDetail';



// WEBPACK FOOTER //
// ./src/app/LegalEntitiesReport/index.ts